import { render, staticRenderFns } from "./downloadXlsx.vue?vue&type=template&id=3bca09ec&scoped=true"
import script from "./downloadXlsx.vue?vue&type=script&lang=js"
export * from "./downloadXlsx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bca09ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bca09ec')) {
      api.createRecord('3bca09ec', component.options)
    } else {
      api.reload('3bca09ec', component.options)
    }
    module.hot.accept("./downloadXlsx.vue?vue&type=template&id=3bca09ec&scoped=true", function () {
      api.rerender('3bca09ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/mdfe/cmp/downloadXlsx.vue"
export default component.exports